import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autofocus"
export default class extends Controller {
  connect() {
    this.element.focus()

    if (this.element.setSelectionRange) {
      const length = this.element.value.length
      this.element.setSelectionRange(length, length)
    }
  }
}
